import {COMMON_BUILDING_CONFIGS, KEY_POINT_CONFIGS, TERRAIN_CONFIGS} from "../configs/tokens";


const prohibitedReconstructionIds = [
    ...KEY_POINT_CONFIGS.map(i => i.id),
    ...TERRAIN_CONFIGS.map(i => i.id),
    ...COMMON_BUILDING_CONFIGS.filter(i => i.isReconstructionProhibited).map(i => i.id)
];

/**
   * Проверить, входит ли строение в перечень тех, которые нельзя перестраивать
   * @param {string} buildingId - Id строения
   * @returns {boolean} true если строение принадлежит игроку
   */
export const isReconstructionProhibited = (buildingId) => {
    return prohibitedReconstructionIds.includes(buildingId);
}



const blockingPathBuildingIds = [
    ...TERRAIN_CONFIGS.map(i => i.id),
];

/**
 * Проверить, входит ли строение в перечень тех, которые нельзя перестраивать
 * @param {string} buildingId - Id строения
 * @returns {boolean} true если строение принадлежит игроку
 */
export const isBlockingPathBuilding = (buildingId) => {
    return blockingPathBuildingIds.includes(buildingId);
}